import { NavLink } from 'react-router'
import { clsx } from 'clsx'
import { RedirectIcon } from '@itsrever/design-system'
import type { PropsWithChildren } from 'react'

interface NavItemProps {
  icon: JSX.Element
  title: string
  to: string
  redirect?: boolean
}

export const NavItem: React.FC<PropsWithChildren<NavItemProps>> = ({
  icon,
  title,
  to,
  redirect,
  children
}) => {
  return (
    <NavLink to={to} target={redirect ? '_blank' : undefined} className="group">
      {({ isActive }) => (
        <li
          className={clsx(
            'flex items-center justify-between gap-2 rounded-lg p-2',
            'fill-[#99A0AE] text-[#99A0AE]',
            'hover:bg-[#2C3242] hover:fill-white hover:text-white hover:outline-1 hover:outline-[#353C4E]',
            isActive &&
              'outline-solid bg-[#2C3242] text-white outline outline-1 outline-[#353C4E]'
          )}
        >
          <div className="flex items-center gap-2">
            <div className={clsx(isActive && 'text-[#098FF9]')}>{icon}</div>
            <p className="text-sm">{title}</p>
            {redirect ? (
              <RedirectIcon className="hidden size-[10px] opacity-50 group-hover:block" />
            ) : null}
          </div>
          {children}
        </li>
      )}
    </NavLink>
  )
}
